export declare type WEIString = string;

export const isWEIString = (value:unknown): value is WEIString => {
	return typeof value === "string" && /^[0-9]+$/.test(value);
}
